import axios from 'axios'

import environment from '@/environment'
import type { AggregateBidOfferRequest } from '@/features/bidding/types/aggregateBidOffer'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const OFFER_AGGREGATE_BID_API_ID = 'OFFER_AGGREGATE_BID'

export const offerAggregateBid = async (request: AggregateBidOfferRequest): Promise<void> => {
  await axios.post(`${PORTFOLIO_MANAGER_API_URL}/aggregate-bidding/bid/offer`, request)
}
